import React, { useEffect } from "react";
import styles from "./AgreementPage.module.scss";
import useWindowSize from "../../hooks/useWindowSize";
import Header from "../../components/header/Header";
import SideBar from "../../components/sideBar/SideBar";
import Footer from "../../components/footer/Footer";
import { useTranslation } from "react-i18next";
import GradientBackdrop from "../../components/shared/GradientBackdrop/GradientBackdrop";
import LinkGuide from "../../components/shared/LinkGuide/LinkGuide";

import { TabsList } from "../../components/shared/Tabs/Tabs";
import RightTabContent from "./RightTabContent";
import LeftTabContent from "./LeftTabContent"


const AgreementPage = () => {
  const { windowSize } = useWindowSize();
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <section className={styles.wrapper}>
      <Header className={styles.headerWrapper} />
      <GradientBackdrop/>

      <div className={styles.container}>
        {windowSize !== "mobile" && <SideBar />}
        <h2 className={styles.termsTitle}>{t("agrtitle")}</h2>

        <TabsList
          titleFirst={t("agreement")}
          titleSecond={t("privacyPolicy")}
          tabContentFirst={<LeftTabContent />}
          tabContentSecond={<RightTabContent />}
        />
      </div>
      <Footer source={""} />
      <LinkGuide/>
    </section>
  );
};

export default AgreementPage;
